import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './UrCompanyListItem.css';
import { COMPANY_STATUS_NEW } from '../common';

const getItems = array => array.map((value, id) => {
  const label = value.formatFunc ? value.formatFunc(value.count) : value.count;
  return (<span key={id} className="UrCompanyListItemNum" style={value.style}>{label}</span>);
});

const UrCompanyListItem = ({
  selected, counters, id, click, name, statusnew
}) => {
  const containerClass = classNames({
    UrCompanyListItem3: true,
    UrCompanyListItemActive: selected
  });

  return (
    <div
      className={containerClass}
      onClick={() => {
        click(id);
      }}
    >
      {name}
      <div style={{
        position: 'absolute',
        right: '10px',
        top: '10px',
        width: '13px',
        height: '13px',
        background: COMPANY_STATUS_NEW.find(obj => obj.id === statusnew).color
      }}
      />
    </div>
  );
};

UrCompanyListItem.defaultProps = {
  id: undefined,
  selected: false,
  click: null,
  accepted: 0,
  counters: []
};

UrCompanyListItem.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  click: PropTypes.func,
  selected: PropTypes.bool,
  counters: PropTypes.arrayOf(PropTypes.shape({
    count: PropTypes.number.isRequired,
    formatFunc: PropTypes.func,
    style: PropTypes.shape({
      color: PropTypes.string
    })
  })),
};

export default UrCompanyListItem;



// WEBPACK FOOTER //
// ./src/components/UrCompanyListItem3.js